import { checkIfKeyExists } from './checkIfKeyExists';
/**
 * Used to sort alphabetically
 * @param column
 */
export const sortAlphabetically = column => {
  return (a, b) => {
    if (!a[column.dataIndex] || !b[column.dataIndex]) {
      return checkIfKeyExists(a, b, column);
    }
    return a[column.dataIndex].localeCompare(b[column.dataIndex]);
  };
};